// 📄 transaccionZService.ts
// Catálogo de transacciones SAP personalizadas (desarrollos Z) por
// proyecto — piloto. Mismo patrón de acceso que incidenteService.ts:
// Firestore DIRECTO desde el cliente (colección
// projects/{projectId}/transaccionesZ), protegido por firestore.rules
// (mismo criterio exacto que incidentes ahí también), a diferencia de
// plantillaReferenciaService.ts que pasa por backend HTTP.
import {
  collection,
  doc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  Timestamp
} from "firebase/firestore";
import { db } from "../firebase";
import { CategoriaTransaccion, SolucionTransaccion } from "./catalogoTransaccionesService.ts";

export type SistemaAmbiente = "DEV" | "QAS" | "PRD";
export const SISTEMAS_AMBIENTE: SistemaAmbiente[] = ["DEV", "QAS", "PRD"];

export interface TransaccionZData {
  codigo: string;
  nombre: string;
  categoria: CategoriaTransaccion;
  solucion: SolucionTransaccion;
  descripcion: string;
  responsable: string;
  sistemasDisponibles: SistemaAmbiente[];
  // Fecha elegida por el usuario (date picker) — a diferencia de
  // creadoEn/actualizadoEn (server timestamps), esta se guarda como
  // Timestamp construido desde el <input type="date"> del formulario
  // (ver TransaccionZFormModal.tsx). null = no se especificó.
  fechaImplementacion: Timestamp | null;
  rolPermiso: string;
  notas: string;
}

export interface TransaccionZ extends TransaccionZData {
  id: string;
  creadoPor: string;
  creadoEn: any;
  actualizadoEn: any;
}

const transaccionesZRef = (projectId: string) => collection(db, "projects", projectId, "transaccionesZ");
const transaccionZRef = (projectId: string, id: string) => doc(db, "projects", projectId, "transaccionesZ", id);

export const getTransaccionesZ = async (projectId: string): Promise<TransaccionZ[]> => {
  const snap = await getDocs(transaccionesZRef(projectId));
  return snap.docs
    .map((d) => ({ id: d.id, ...(d.data() as Omit<TransaccionZ, "id">) }))
    .sort((a, b) => a.nombre.localeCompare(b.nombre));
};

export const crearTransaccionZ = async (projectId: string, data: TransaccionZData, creadoPor: string): Promise<string> => {
  if (!data.codigo.trim()) throw new Error("El código es obligatorio.");
  if (!data.nombre.trim()) throw new Error("El nombre es obligatorio.");

  const ref = doc(transaccionesZRef(projectId));
  await setDoc(ref, {
    ...data,
    codigo: data.codigo.trim(),
    nombre: data.nombre.trim(),
    creadoPor,
    creadoEn: serverTimestamp(),
    actualizadoEn: serverTimestamp()
  });
  return ref.id;
};

export const actualizarTransaccionZ = async (projectId: string, id: string, data: TransaccionZData): Promise<void> => {
  if (!data.codigo.trim()) throw new Error("El código es obligatorio.");
  if (!data.nombre.trim()) throw new Error("El nombre es obligatorio.");

  await updateDoc(transaccionZRef(projectId, id), {
    ...data,
    codigo: data.codigo.trim(),
    nombre: data.nombre.trim(),
    actualizadoEn: serverTimestamp()
  });
};

export const eliminarTransaccionZ = async (projectId: string, id: string): Promise<void> => {
  await deleteDoc(transaccionZRef(projectId, id));
};
